let timerId;
const changeHash = (hash) => {
	document.querySelectorAll('[data-hash]').forEach(($element) => {
		if ($element.dataset.hash === hash) {
			$element.click();
		}
	});

	if (timerId) {
		clearTimeout(timerId);
	}

	timerId = setTimeout(() => {
		document.querySelector('[data-scroll-container]').classList.remove('not-loaded');
	}, 100);
}; 

window.addEventListener('hashchange', () => {
	const newHash = window.location.hash.substring(1);

	changeHash(newHash);
});

changeHash(window.location.hash.substring(1));